import { render } from "./AcpNavigation.vue?vue&type=template&id=4fbba2e2&ts=true"
import script from "./AcpNavigation.vue?vue&type=script&lang=ts"
export * from "./AcpNavigation.vue?vue&type=script&lang=ts"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__